import React from 'react'
import './Casestudy.css';
// import Portfolio from './Portfolio';
import Box from './Box';
import Button from './Button';
import Gfooter from '../Component/Gfooter';
import Casestudy4 from './Casestudy4';
import Box1 from './Box1';
import Box2 from './Box2';
import CaseStudies from './CaseStudies';


function CaseStudy() {
    return ( 
        <>
        <div className='case-sd'>

        
        {/* <div className='container-fluid case-study-banner-top'>
                  <div className="case-study-image col-lg-12 col-md-12 col-sm-12">
         <img src="about-img/Artboard 5.jpg" alt="case study banner"/>
         <div className="case-study-banner aos-init aos-animate" data-aos="fade-up">
                  <h1 className="text-white">Case Study</h1>
                  <p>"Explore how we turned challenges into success with our proven strategies in this detailed case study."</p>
                  <div className="case-study-box">
                    <span className="mb-0 box-home">Home</span>
                    <span className="mb-0 arrow"><i className="fa-solid fa-arrow-right"></i></span>
                    <span className="mb-0 box_span">Case Study</span>
                  </div>
                </div>
         </div>
         </div> */}
        {/* <Box/>   real box of old website */}
        {/* <Box1/> */}
        {/* <Box2/>  real box second of website*/}
        <CaseStudies/>
        {/* <Casestudy4/> */}
        {/* <Portfolio/> */}
        <Button/>
        </div>
<Gfooter/>
        </>
     );
}

export default CaseStudy;


